/*
Documentation

this page holds all of our layouts and functions
that need to fire before the app runs

*/

import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Auth from 'views/auth/layout';
import Bankruptcy from 'views/bankruptcy/layout';
import Roadside from 'views/roadside/layout';
import Account from 'views/account/layout';
import Cases from 'views/cases/layout';
import Actions from 'views/actions/layout';
import Errors from 'views/errors/layout';

import FailedConnection from 'views/errors/pages/errors/FailedConnection';

import SystemAlertBS from 'components/markup/system/AlertBS'
import SystemAlert from 'components/markup/system/Alert'
import SystemLoader from 'components/markup/system/Loader'
import StandardLoader from 'components/markup/system/StandardLoader'

import LoggedInRoute from 'components/system/Routing/LoggedInRoute'

import init from './init'
 
class App extends Component {

    state = {
        loaded: false,
        error: false
    };

    componentDidMount = async () => {

        if(window.location.pathname === '/review') {

            const links = [
                'https://g.page/r/CdBAP3YCNl4sEB0/review',
                'https://g.page/r/CUHLcd-QjSo0EAE/review',
                'https://g.page/r/CSK0Sm0DPilIEAE/review',
                'https://g.page/r/CWpShx7e8KuXEAE/review',
                'https://g.page/r/CcsehNkneC87EAE/review',
                'https://g.page/r/CdQt4pXHtH7YEAE/review',
                'https://g.page/r/CfLtwlAVqxo7EAE/review',
                'https://g.page/r/Cd8T6FMynMsBEAE/review',
                'https://g.page/r/CfKk1LmRw6uOEAE/review',
                'https://g.page/r/CeFw9MB91dxWEAE/review',
                'https://g.page/r/CdwiVLVjJADcEAE/review',
                'https://g.page/r/CcUv2i_N2PF-EAE/review',
                
                // CLEVELAND OHIO PI
                'https://g.page/r/CZb08nDBRtUKEAI/review',
            ]
            
            return window.location.href = links[Math.floor(Math.random() * links.length)]
        }

        const loadedSuccessfully = await init();
        this.setState({loaded: true, error: !loadedSuccessfully})
    }

    componentDidCatch = (e) => {

        //don't redirect if we are developing
        if(window.location.hostname !== 'localhost') {
            this.setState({shouldRedirect: `/errors/standard?error=${e}&referrerurl=${window.location.href}`})
        }

    }

    render() {

        if(this.state.shouldRedirect) {
            return window.location.href = this.state.shouldRedirect
        }

        if(!this.state.loaded) {
            return <div></div>
        }

        if(this.state.error) {
            return <FailedConnection />
        }

        return (

            <>

                <SystemAlertBS />
                <SystemAlert />
                <SystemLoader />
                <StandardLoader />

                <BrowserRouter>
                    <Switch>

                        <Route path="/cases" render={props => 
                            <LoggedInRoute>
                                <Cases {...props} /> 
                            </LoggedInRoute>
                        } />
                        <Route path="/bankruptcy" render={props => 
                            <LoggedInRoute>
                                <Bankruptcy {...props} /> 
                            </LoggedInRoute>
                        } />
                        <Route path="/roadside" render={props => 
                            <LoggedInRoute>
                                <Roadside {...props} /> 
                            </LoggedInRoute>
                        } />
                        <Route path="/account" render={props => 
                            <LoggedInRoute>
                                <Account {...props} /> 
                            </LoggedInRoute>
                        } />
                        <Route path="/actions" render={props => 
                            <LoggedInRoute>
                                <Actions {...props} /> 
                            </LoggedInRoute>
                        } />

                        <Route path="/errors" render={props => <Errors {...props} /> } />
                        <Route path="/" render={props => <Auth {...props} /> } />

                    </Switch>
                </BrowserRouter>

            </>

        )

    }

}

export default App
